import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=12857f79&scoped=true&"
import script from "./SmsList.vue?vue&type=script&lang=js&"
export * from "./SmsList.vue?vue&type=script&lang=js&"
import style0 from "./SmsList.vue?vue&type=style&index=0&id=12857f79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12857f79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VContainer,VRow,VTab,VTabs})
